var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "club-points-history-table-desktop" },
    [
      _c("div", { staticClass: "club-points-history-table-desktop__row" }, [
        _c(
          "div",
          { staticClass: "club-points-history-table-desktop__cell operation" },
          [_c("cell-label", [_vm._v("Операция")])],
          1
        ),
        _c(
          "div",
          { staticClass: "club-points-history-table-desktop__cell date" },
          [
            _c(
              "vue-client-only",
              [
                _c("cell-label", [
                  _vm._v(
                    _vm._s(_vm.adaptive.isDesktop ? "Дата операции" : "Дата")
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "club-points-history-table-desktop__cell sum" },
          [_c("cell-label", [_vm._v("Остаток")])],
          1
        ),
        _c(
          "div",
          {
            staticClass: "club-points-history-table-desktop__cell description"
          },
          [_c("cell-label", [_vm._v("Подробнее")])],
          1
        ),
        _c(
          "div",
          { staticClass: "club-points-history-table-desktop__cell burnsAt" },
          [_c("cell-label", [_vm._v("Дата сгорания")])],
          1
        )
      ]),
      _vm._l(_vm.historyRecords, function(record, index) {
        return _c(
          "div",
          { key: index, staticClass: "club-points-history-table-desktop__row" },
          [
            _c(
              "div",
              {
                staticClass: "club-points-history-table-desktop__cell operation"
              },
              [
                _c("points", {
                  attrs: {
                    value: record.bonusesUsed,
                    "is-add-mode": record.bonusesUsed > 0
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "club-points-history-table-desktop__cell date" },
              [
                _c("cell-value", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.valueOrEmpty(_vm.formatDate(record.date))) +
                      "\n      "
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "club-points-history-table-desktop__cell sum" },
              [
                _c("cell-value", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.valueOrEmpty(
                          _vm.$options.filters.price(record.bonusesTotal)
                        )
                      ) +
                      "\n      "
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "club-points-history-table-desktop__cell description"
              },
              [
                _c(
                  "cell-value",
                  [
                    _c("history-description", {
                      attrs: {
                        description: _vm.valueOrEmpty(record.description),
                        "order-number": record.orderNumber,
                        receipt: record.receipt
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "club-points-history-table-desktop__cell burnsAt"
              },
              [
                _c("cell-value", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.valueOrEmpty(_vm.formatDate(record.dateEnd))) +
                      "\n      "
                  )
                ])
              ],
              1
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }